import { render, staticRenderFns } from "./PermissionListener.vue?vue&type=template&id=c04c66a4&"
import script from "./PermissionListener.vue?vue&type=script&lang=js&"
export * from "./PermissionListener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports